export const ROW_ACTIONS_CONFIG = {
  getOnClickProps: item => item,
}
